import { PhoneDto, SendPhoneConfirmationDto, VerifyPhoneConfirmationDto, VerifyPhoneConfirmationResultDto } from '@/types/webapi';
import { IProfileService } from './IProfileService';
import { injectable } from 'inversify';
import { ax } from '@/plugins/axios';

@injectable()
export class ProfileService implements IProfileService {
    sendPhoneConfirmation(phone: PhoneDto, recaptchaToken: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            ax.post('/api/bff/profile/phone-confirmation', {
                phone,
                recaptchaToken: recaptchaToken
            } satisfies SendPhoneConfirmationDto)
                .then(() => resolve())
                .catch(reject);
        });
    }

    verifyPhoneConfirmation(phone: PhoneDto, code: string, recaptchaToken: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            ax.post<VerifyPhoneConfirmationResultDto>('/api/bff/profile/phone-confirmation/verification', {
                phone,
                code,
                recaptchaToken: recaptchaToken
            } satisfies VerifyPhoneConfirmationDto)
                .then(response => resolve(response.data.verified || false))
                .catch(reject);
        });
    }
}
